var _linearGradient, _path, _radialGradient, _circle, _circle2, _radialGradient2, _circle3, _circle4, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "KSO7WLFLBNFgc821jKHL3a",
    x1: 24,
    x2: 24,
    y1: 6.53,
    y2: 42.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#6d7882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#45494d"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#KSO7WLFLBNFgc821jKHL3a)",
    d: "M43,10h-9.839c-0.608,0-1.182-0.276-1.562-0.751L29.6,6.751C29.221,6.276,28.646,6,28.039,6 h-8.077c-0.608,0-1.182,0.276-1.562,0.751L16.4,9.249C16.021,9.724,15.446,10,14.839,10H5c-1.105,0-2,0.895-2,2v27 c0,1.105,0.895,2,2,2h38c1.105,0,2-0.895,2-2V12C45,10.895,44.105,10,43,10z"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "KSO7WLFLBNFgc821jKHL3b",
    cx: 24,
    cy: 25.5,
    r: 13.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 25.5,
    r: 13.5,
    fill: "url(#KSO7WLFLBNFgc821jKHL3b)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 25,
    r: 11,
    fill: "#fff"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "KSO7WLFLBNFgc821jKHL3c",
    cx: 18.5,
    cy: 19.554,
    r: 16.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bd8af5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#b88bf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#a88ff3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#8f96f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#6b9eef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#3eaaec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29afea"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 25,
    r: 8,
    fill: "url(#KSO7WLFLBNFgc821jKHL3c)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 16,
    r: 2,
    fill: "#eef2f3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0076d7",
    d: "M14,10H7V9c0-0.552,0.448-1,1-1h5c0.552,0,1,0.448,1,1V10z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.2e279adde54e59fcd7873730474c26ef.svg";
export { ForwardRef as ReactComponent };